var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
        'promotions-mark': true
    }, _obj['promotions-mark--status--' + _vm.status] = true, _obj['promotions-mark--new'] =  _vm.isNewProgram, _obj['promotions-mark--empty'] =  !_vm.daysCount, _obj ),attrs:{"data-days":_vm.daysCount || undefined,"data-corner-value":_vm.cornerValue,"data-provider":_vm.provider,"data-hotelid":_vm.hotelId,"data-program":_vm.program}},[_c('div',{domProps:{"textContent":_vm._s(_vm.daysCount || '')}})])}
var staticRenderFns = []

export { render, staticRenderFns }